module.exports = __webpack_public_path__ + "img/craft.2846416c.png";